import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import {
  makeStyles,
  withStyles,
  Box,
  Button,
  Typography,
} from "@material-ui/core";
import Gradient from "javascript-color-gradient";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";

import LoaderView from "../../../components/LoaderView";
import { isEmptyObject } from "utils";

const useStyles = makeStyles({});

const ActivityHoursByEmployee = (props) => {
  const {
    employeeActivityHoursData,
    employeeActivityHoursDataLoading,
    districtBuildingMapLoading,
  } = props;

  const { employeeHoursData, employeeHoursTotalData } =
    employeeActivityHoursData;

  const classes = useStyles(),
    { t } = useTranslation();

  const [activityOptions, setActivityOptions] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState("");
  const [employeeActivityData, setEmployeeActivityData] = useState([]);
  const [employeeActivityDataToShow, setEmployeeActivityDataToShow] = useState(
    []
  );
  const [employeeActivityTotalData, setEmployeeActivityTotalData] = useState(
    []
  );
  const [isEmployeeActivityDataAvailable, setIsEmployeeActivityDataAvailable] =
    useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [colorGradientArray, setColorGradientArray] = useState([]);

  const employeeDataRestrictedLength = 4;

  const buttonDisabled = (dataLength) => {
    if (dataLength < employeeDataRestrictedLength) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };

  const onShow = () => {
    if (employeeActivityDataToShow.length === employeeDataRestrictedLength) {
      setEmployeeActivityDataToShow(employeeActivityData);
    } else {
      setEmployeeActivityDataToShow(
        employeeActivityData.slice(0, employeeDataRestrictedLength)
      );
    }
  };

  useEffect(() => {
    if (employeeActivityDataToShow.length === employeeDataRestrictedLength) {
      setEmployeeActivityDataToShow(employeeActivityData);
    } else {
      setEmployeeActivityDataToShow(
        employeeActivityData.slice(0, employeeDataRestrictedLength)
      );
    }

    const gradientArray = new Gradient()
      .setColorGradient("#02f7d2", "#03947e")
      .setMidpoint(employeeActivityData.length)
      .getColors();

    setColorGradientArray(gradientArray);
  }, [employeeActivityData]);

  useEffect(() => {
    if (employeeHoursData) {
      const activityOptionsList = Object.keys(employeeHoursData);
      if (!isEmptyObject(activityOptionsList)) {
        setActivityOptions(activityOptionsList);
      } else {
        setActivityOptions([]);
        setSelectedActivity("");
      }
    }
  }, [employeeActivityHoursData]);

  useEffect(() => {
    if (employeeHoursData && employeeHoursTotalData) {
      const employeeData = employeeHoursData[selectedActivity];
      const employeeTotalData = employeeHoursTotalData[selectedActivity];
      if (employeeData && employeeTotalData) {
        employeeData.sort(
          (a, b) => parseFloat(b.activityHours) - parseFloat(a.activityHours)
        );
        buttonDisabled(employeeData.length);
        setEmployeeActivityData(employeeData);
        setEmployeeActivityTotalData([employeeTotalData]);
        setIsEmployeeActivityDataAvailable(true);
      } else {
        setIsEmployeeActivityDataAvailable(false);
      }
    } else {
      setIsEmployeeActivityDataAvailable(false);
    }
  }, [selectedActivity, employeeActivityHoursData]);

  return (
    <>
      <LoaderView
        loading={employeeActivityHoursDataLoading || districtBuildingMapLoading}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={3}
        >
          <Grid item>
            <Autocomplete
              options={activityOptions}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setSelectedActivity(newValue);
                } else {
                  setSelectedActivity("");
                }
              }}
              value={selectedActivity}
              style={{ width: 200 }}
              renderInput={(params) => {
                if (selectedActivity === "") {
                  return <TextField {...params} label="Select Activity" />;
                } else {
                  return <TextField {...params} label="Activity" />;
                }
              }}
            />
          </Grid>
          {/* <Grid item> */}
          {isEmployeeActivityDataAvailable ? (
            <>
              {/* <Grid
                  container
                  spacing={3}
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                > */}
              <Grid item xs="auto">
                <Typography variant="h6">Total</Typography>
              </Grid>
              <Grid item xs="auto">
                <BarChart
                  width={500}
                  height={50}
                  data={employeeActivityTotalData}
                  layout="vertical"
                >
                  <XAxis type="number" hide axisLine={false} />
                  <YAxis
                    dataKey="totalHours"
                    orientation="left"
                    type="category"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "#1b75bc", fontSize: 25 }}
                  />
                  <Tooltip
                    wrapperStyle={{ zIndex: 1 }}
                    labelFormatter={function (value) {
                      return ``;
                    }}
                  />

                  {employeeActivityData.map((employeeActivity, index) => (
                    <Bar
                      dataKey={employeeActivity.employeeNameId}
                      stackId="a"
                      fill={colorGradientArray[index]}
                    />
                  ))}
                </BarChart>
              </Grid>
              {/* </Grid> */}
            </>
          ) : null}
          {/* </Grid> */}
        </Grid>

        {isEmployeeActivityDataAvailable ? (
          <>
            <BarChart
              width={730}
              height={70 * employeeActivityDataToShow.length}
              data={employeeActivityDataToShow}
              margin={{ left: 75, top: 10, bottom: 10 }}
              layout="vertical"
            >
              <XAxis type="number" hide axisLine={false} />
              <YAxis
                dataKey="employeeNameId"
                orientation="left"
                type="category"
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                formatter={function (value, name) {
                  return [`${value}`, "Duration"];
                }}
                labelFormatter={function (value) {
                  return ``;
                }}
              />
              <Bar dataKey="activityHours" name="Hours" fill="#00a88e">
                {employeeActivityDataToShow.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colorGradientArray[index]}
                  />
                ))}
              </Bar>
            </BarChart>

            <Button
              disabled={isButtonDisabled}
              onClick={() => {
                onShow();
              }}
              color="primary"
            >
              {employeeActivityDataToShow.length ===
              employeeDataRestrictedLength
                ? "Show More"
                : "Show Less"}
            </Button>
          </>
        ) : (
          <Grid style={{ marginTop: "30px" }}>
            <Box className={classes.full}>
              <Alert severity="info">{t("pgHome.errNoReportData2")}</Alert>
            </Box>
          </Grid>
        )}
      </LoaderView>
    </>
  );
};

export default ActivityHoursByEmployee;
